import React, {useEffect, useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUserId, resetAllLoaded, setCurrentUserId, setUserStateLoaded, usersListState, useUsersListSnapshot } from 'store/storeValtio';
import chevLeft from 'icons/chevron-left-24.png';
import addIcon from 'icons/plus-circle-24.png';
import HelpTitle from '../common/HelpTitle';
import Spinner from '../spinner/Spinner';
import './users.css';
import { getUsersFromDb } from 'store/localDb';

export default function ChangeUser() {
  console.log("ChangeUser");

  const navigate = useNavigate();

  useEffect(() => {
    getUsersFromDb();
    console.log("Got users");
    console.log(usersListState);

  },[]);

  const uls = useUsersListSnapshot();
  const usersList = uls.usersList;
  const currentUserId = getCurrentUserId();
  console.log('CU list', usersList);

  function changeUser(id) {
      console.log('changeUser', id, currentUserId);
      if (id === currentUserId) {
        return;
      }

      resetAllLoaded();
      localStorage.setItem('currentUser', id );
      setUserStateLoaded(false);
      setCurrentUserId(id);
      navigate('/');
  }

  function addUser() {
    navigate('/addUser');
  }

  return (
    <div className='pt-8 h-full flex flex-col justify-normal items-center text-center font-bold text-2xl bg-blue-200 '>
      {/* <ConfirmModal
        open={popup.show}
        confirmButton={popup.confirm}
        onConfirm={() => handleDeleteTrue()}
        onCancel={() => handleDeleteFalse()}
        title={popup.userName}
        content={popup.content}
      /> */}

      <HelpTitle title="Change/Add User" helpSubject="ChangeUser" />
      <div className='mt-4 mx-auto w-full max-w-md'>
        <div className='changeUser py-8'>
          <ul className='flex flex-col items-center'>
            {usersList.map((u, ix) => {
              //console.log('u', u);
              const current = u.userId === currentUserId;
              const bg = current ? 'bg-gray-300 disabled-li' : 'bg-blue-300';
              return (
                <li key={ix}
                  className={bg}
                  id={ix + 1}
                  onClick={() => changeUser(u.userId)}
                >
                  {u.displayName}
                </li>
                )
              })
            }
            <li key={99}
              className='bg-blue-300'
              id={99}
              onClick={() => addUser()}
            >
              Add New User
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

